export default "__VITE_ASSET__D4de4Nb___"